import { skipToken } from '@reduxjs/toolkit/query'
import { type User } from '../../models/User'
import { selectAccountId } from '../../store/auth/authSlice'
import { useAppSelector } from '../../store/hooks'
import { useDownloadGlobalFileRequestQuery } from '../../store/media/file'
import { useGetUserByIdQuery } from '../../store/user/user'
import { getUserInitials } from '../../views/utils'

type UseUserAvatarSource = {
  user?: User | null
  userId?: string
  name?: string
}

export type UserAvatarSource = {
  imageUrl?: string
  initialLetters: string
}

export const useUserAvatarSource = ({ user, userId, name }: UseUserAvatarSource): UserAvatarSource => {
  const accountId = useAppSelector(selectAccountId)

  const lookupId = user?.settings === undefined ? (user?.id ?? userId) : undefined
  const { currentData: fetchedUser } = useGetUserByIdQuery(lookupId ? { accountId, userId: lookupId } : skipToken)

  const resolvedUser = fetchedUser?.data ?? user ?? undefined
  const fileId = resolvedUser?.settings?.assets?.avatar?.avatarFile?.fileId
  const { currentData: download } = useDownloadGlobalFileRequestQuery(fileId ? { accountId, fileId } : skipToken)

  return {
    imageUrl: fileId ? download?.data.location : undefined,
    initialLetters: getUserInitials(resolvedUser, name),
  }
}
